import jsPDF from 'jspdf'
import { fontNunitoNormal, fontNunitoBold } from '@/assets/fonts/Nunito-Fonts-Base64.js'
import { mapGetters } from 'vuex'
const notesBaseImage = require('@/assets/js/notesBase.js')
const { convert } = require('html-to-text')
const marginBetweenLabelAndValue = 2
const lineStartValue = 14

export default {
    data () {
        return {
            notesBaseImage: '',
        }
    },
    computed: {
        ...mapGetters({
            user: 'User/getCurrentUser',
        })
    },
    methods: {
        setupNewPdfPage (certificate) {
            certificate.setFont('Nunito-Regular')
            let height = 290
            let width = 210
            certificate.addImage(this.notesBaseImage, 'JPEG', 0, 7, width, height)
            return certificate
        },
        addPageNumber (certificate, pageNumber) {
            certificate.setFont('Nunito-Bold')
            certificate.setFontSize(13)
            certificate.text(185, 8, this.$t('Notes.pdf_pagenumber') + ' ' + pageNumber.toString())
            certificate.setFont('Nunito-Regular')
            return certificate
        },
        getNewPdfObject () {
            const certificate = new jsPDF()
            certificate.addFileToVFS('Nunito-Regular-normal.ttf', fontNunitoNormal)
            certificate.addFont('Nunito-Regular-normal.ttf', 'Nunito-Regular', 'normal')
            certificate.addFileToVFS('Nunito-Bold-normal.ttf', fontNunitoBold)
            certificate.addFont('Nunito-Bold-normal.ttf', 'Nunito-Bold', 'normal')
            return certificate
        },
        createNotesPdf (notes) {
            let certificate = this.getNewPdfObject()
            certificate.setFont('Nunito-Regular')
            certificate.setTextColor('black')
            let height = 290
            let width = 210
            certificate.addImage(this.notesBaseImage, 'JPEG', 0, 7, width, height)
            certificate.setFontSize(28)
            certificate.setTextColor('#e47700')
            certificate.setFont('Nunito-Bold')
            certificate.text(14, 47, this.$t('Notes.pdf_description'))
            certificate.setFont('Nunito-Regular')
            certificate.setTextColor('black')
            certificate.setFontSize(16)
            certificate.text(14, 55, this.$t('Notes.pdf_user'))
            certificate.text(this.getLineCoordinateForAttribute(certificate, this.$t('Notes.pdf_user')), 55, this.user.firstName + ' ' + this.user.lastName)
            certificate.text(14, 62, this.$t('Notes.pdf_course'))
            let splittedTitle = certificate.splitTextToSize(notes.courseTitle, 140)
            certificate.text(this.getLineCoordinateForAttribute(certificate, this.$t('Notes.pdf_course')), 62, splittedTitle)

            certificate.setFontSize(14)
            if (notes.content.length > 1650) {
                let pageNumber = 1
                this.addPageNumber(certificate, pageNumber)
                let splittedNotes = notes.content.match(/.{1,1650}/g)
                splittedNotes.forEach((note, index) => {
                    let splittedNote = certificate.splitTextToSize(convert(note.toString()), 160)
                    certificate.text(26, 90, splittedNote)
                    if (index !== (splittedNotes.length - 1)) {
                        certificate.addPage()
                        this.setupNewPdfPage(certificate)
                        pageNumber += 1
                        this.addPageNumber(certificate, pageNumber)
                    }
                })
            } else {
                let splittedContent = certificate.splitTextToSize(convert(notes.content), 160)
                certificate.text(26, 90, splittedContent)
            }
            certificate.setProperties({
                title: 'Koulutuksen Muistiinpanot - ' + notes.courseTitle
            })
            window.open(certificate.output('bloburl'))
        },
        getLineCoordinateForAttribute (certificate, label) {
            return (certificate.getTextWidth(label) + marginBetweenLabelAndValue + lineStartValue)
        }
    },
    mounted () {
        this.notesBaseImage = notesBaseImage.notesString
    }
}
